import React from 'react'
import { Box } from '@mui/material'
import MarketingHeader from '../components/marketing/MarketingHeader'

interface MarketingLayoutProps {
  children: React.ReactNode
}

export default function MarketingLayout({ children }: MarketingLayoutProps) {
  const handleLogin = () => {
    // Navigate to login page
    window.location.href = '/login'
  }

  const handleSignUp = () => {
    // TODO: Navigate to signup page when implemented
    window.location.href = '/signup'
  }

  return (
    <Box>
      <MarketingHeader onLogin={handleLogin} onSignUp={handleSignUp} />
      {/* Add top padding to account for fixed header */}
      <Box sx={{ pt: '64px' }}>
        {children}
      </Box>
    </Box>
  )
}